<template>
  <div id="diagnosis-block" class="diagnostic-container">
    <div v-if="openDiagnostic" class="modal diagnostic-modal" :class="{ visible: openDiagnostic }">
      <div class="modal__overlay" @click="openDiagnostic = false"></div>
      <div class="modal__body lazyload" :style="modalBackground">
        <div class="modal__body__close" @click="closeModal()">
          <svg class="icon-close">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-icon"></use>
          </svg>
        </div>
        <div class="modal__content">
          <div v-if="showDiagnosticSections" class="diagnostic-modal-bg">
            <product-diagnostic
              ref="product"
              :initialdata="diagnosticProductData"
              @show-diagnostic="openRecommendedProducts"
            ></product-diagnostic>
          </div>
          <div v-else class="container">
            <h3 v-if="getResultHeading" class="diagnostic-result-heading">
              {{ getResultHeading }}
            </h3>
            <div class="row diagnostic-result-container">
              <div class="col-lg-3 col-md-3 col-sm-4">
                <div class="routine-description">
                  <div class="diagnostic-result-img-box">
                    <img
                      v-if="productResults.resultImage && productResults.resultImage.Src"
                      :src="productResults.resultImage.Src"
                      :alt="productResults.resultImage.Alt"
                    />
                  </div>
                  <h3 v-if="productResults.resultTitle">
                    {{ productResults.resultTitle }}
                  </h3>
                  <p v-if="productResults.resultDescription">
                    {{ productResults.resultDescription }}
                  </p>
                </div>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-8">
                <recommended-product-list
                  :product-list="productResults.resultTag"
                  :button-text="getCtaText"
                ></recommended-product-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'diagnostic-modal',
  props: {
    initialdata: { type: String, required: true },
  },
  data() {
    return {
      showDiagnosticSections: true,
      productResults: [],
      openDiagnostic: false,
      dataLayerobj: {},
    };
  },
  computed: {
    diagnosticProductData() {
      const diagnosticData = this.initialdata ? JSON.parse(this.initialdata) : [];
      return diagnosticData;
    },
    modalBackground() {
      const bgImage = this.diagnosticProductData[0].backgroundImage;
      return this.showDiagnosticSections ? { backgroundImage: `url( ${bgImage.Src})` } : {};
    },
    getCtaText() {
      const ctaText = this.diagnosticProductData ? this.diagnosticProductData[0].cta : '';
      return ctaText;
    },
    getResultHeading() {
      const heading = this.diagnosticProductData
        ? this.diagnosticProductData[0].resultHeadingTitle
        : '';
      return heading;
    },
  },
  mounted() {
    this.dataLayerobj = dataLayer[0];
    dataLayer.push({
      brand: this.dataLayerobj['brand'],
      country: this.dataLayerobj['country'],
      siteTypeLevel: this.dataLayerobj['siteTypeLevel'],
      language: this.dataLayerobj['language'],
      cid: this.dataLayerobj['cid'],
      pageCategory: 'content page::augmented products',
    });
    window.eventBus.$on('openDiagnosticModel', () => {
      this.openDiagnostic = true;
    });
  },
  methods: {
    openRecommendedProducts(resultProduct) {
      this.showDiagnosticSections = false;
      this.productResults = resultProduct;
    },
    closeModal() {
      if (this.showDiagnosticSections) {
        this.$refs.product.resetData();
      }
      this.productResults = [];
      this.showDiagnosticSections = true;
      this.openDiagnostic = false;
    },
  },
};
</script>
